export default "__VITE_ASSET__DUABy162__"